<template>
  <div class="sm:mt-3 -mb-[50px] flex justify-center">
    <button v-if="loggedIn && !spot.gotFixed"
            class="z-10"
            @click="toggleVote">
      <SpotDetailsVoteIcon class="spot-vote-icon-hover"
                           :spot="spot"
                           :voted="hasVoted"
                           :numberOfVotes="numberOfVotes" />
    </button>
    <NuxtLink v-if="!loggedIn && !spot.gotFixed"
              class="z-10"
              to="/login">
      <SpotDetailsVoteIcon :spot="spot"
                           :voted="hasVoted"
                           :numberOfVotes="numberOfVotes" />
    </NuxtLink>
    <SpotDetailsVoteIcon v-if="spot.gotFixed"
                         class="z-10"
                         :spot="spot"
                         :voted="hasVoted"
                         :numberOfVotes="numberOfVotes" />
  </div>
</template>
<script setup lang="ts">
const { $api } = useNuxtApp()

const props = defineProps<{ spot: SpotDetail, voted?: boolean }>()

const {loggedIn } = useUserSession();
const hasVoted = ref(props.voted);
const numberOfVotes = ref(props.spot?.numberOfVotes);

watch(() => props.voted, (value: boolean | undefined) => {
  hasVoted.value = value ? value : false;
});

function toggleVote() {
  let endpoint = 'vote';

  if (hasVoted.value) {
    endpoint = "unvote";
  }

 $api("spots/" + props.spot?.id.toString() + "/" + endpoint, { method: 'POST' }).then(function (response) {
    hasVoted.value = !hasVoted.value;
    if (hasVoted.value) {
      numberOfVotes.value++;
      props.spot.userData.follows = true;
    } else {
      numberOfVotes.value--;
    }
  });
}
</script>
<style lang="postcss" scoped>
:deep(.spot-vote-icon-hover:hover) {
  circle {
    @apply fill-black stroke-black;
  }

  .thumb {
    @apply stroke-white fill-white;
  }

}
</style>
